require([
	'jquery',
	'root/Base/Js/MbiImageSize',
	'flickity',
    'base/MbiHelper',
	'base/MbiMediaQuery',
    'gmaps',
    'root/Assets/Js/Validate',

    'root/Assets/Js/HoverHandler',
    'base/MbiLazySizes',
    'root/Base/Js/Vendor/PictureFill',
    'root/Assets/Js/Templates',
	'root/Assets/Js/Vendor/cookie',

], function(
	$,
	mbiImageSize,
	Flickity,
	_,
    mbiMq,
    GMaps,
    V
	) {
	'use strict';

	$(document).on('click', '.js_openText', function(e){
		var textmore = $(this).siblings('.text-more');
		if ($(textmore).hasClass('is_visible')) {
			$(textmore).removeClass('is_visible');
			$(this).html($(this).attr('data-closed'));
		} else {
			$(textmore).addClass('is_visible');
			$(this).html($(this).attr('data-opened'));
			$('body, html').animate({
				scrollTop: $(textmore).offset().top - 140
			}, 350);
		}
	});




    $(document).on('click', '.js_playVideo', function(e){
       var video = $('.grid-video').get(0);
       if (video.paused) {
            video.play();
            $('.js_playVideo').addClass('playing');
        } else {
            video.pause();
            $('.js_playVideo').removeClass('playing');
        }
    });

function initSwiper() {

    var flktyObjects = [];
    if(_.exists('.swiper')) {
        $('.swiper').each(function() {
            if($(this).find('.slide').length > 1) {
            	var $container = $(this);
                if($(this).find('.slide').length >= 1) {
                    var prvbt = true;
                    var autoplay = 4500;
                    var cellAlign = 'center';
                    var wraparo = true;
                    var draga = true;
                    var pagedots = true;
                    if($(this).hasClass('offer-slider')) {
                        cellAlign = 'left';
                        prvbt = true;
                        pagedots = false;
                        autoplay = 4500;
                    }
                    var $options = {
                        cellSelector: '.slide',
                        pageDots: pagedots,
                        wrapAround: wraparo,
                        autoPlay: autoplay,
                        draggable: draga,
                        prevNextButtons: prvbt,
                        lazyLoad: true,
                        cellAlign: cellAlign,
                        // setGallerySize: false,
                        arrowShape: {
                          x0: 25,
                          x1: 60, y1: 35,
                          x2: 65, y2: 30,
                          x3: 35
                        }
                  }
                    document.ontouchmove = function(e){
                        return true;
                    };
                    var flktyid = '#'+$(this).attr('id');
                    var flkty = new Flickity(flktyid, $options);
                    flktyObjects[flktyid] = flkty;
                    var carouselStatus = $(flktyid).parent().find('.offer-status');

                    function updateStatus() {
                      var slideNumber = flktyObjects[flktyid].selectedIndex + 1;
                      carouselStatus.html(slideNumber + '/' + flktyObjects[flktyid].slides.length);
                    }
                    updateStatus();

                    flktyObjects[flktyid].on( 'select', updateStatus);
                }
                $(this).addClass('is-visible');
            }
        });
        setTimeout(function(){
            mbiImageSize.init();
        },100);
    }
}

// var map = '';
var maps = [];
var markers = [];
var $urlPrefix = '';
function initMap() {
    if(_.exists('.map')) {
        $('.map').each(function(index, el) {
            var $id = $(this).attr('id');
            var map = '';

        var styles = [{"featureType":"road","elementType":"geometry","stylers":[{"lightness":100},{"visibility":"simplified"}]},{"featureType":"water","elementType":"geometry","stylers":[{"visibility":"on"},{"color":"#C6E2FF"}]},{"featureType":"poi","elementType":"geometry.fill","stylers":[{"color":"#C5E3BF"}]},{"featureType":"road","elementType":"geometry.fill","stylers":[{"color":"#ffffff"}]}];

        if($('html').hasClass('touch')) {
            var $disable = false;
        } else {
            var $disable = true;
        }
        if($(this).hasClass('map-full')) {
            if (window.matchMedia('(max-width: 1920px)').matches) {
                var z = 8;
            } else {
                var z = 9;
            }
        } else {
            var z = 12;
        }

        map = new GMaps({
            el: '#' + $id,
            lat: 47.4573846,
            lng: 12.7644253,
            // lat: 47.4153577,
            // lng: 13.0254568,
            zoomControl : true,
            scrollwheel: false,
            zoom: z,
            zoomControlOpt: {
                style : 'SMALL',
                position: 'TOP_LEFT'
            },
              dragend: function(e) {
                // console.log(this.getBounds());
                // var test = this.getBounds();
                // search();
              },
            draggable: true,
            disableDoubleClickZoom: true,
            panControl : false,
            streetViewControl : false,
            mapTypeControl: false,
            overviewMapControl: false,
            mapTypeControlOptions: {
              mapTypeIds: [google.maps.MapTypeId.ROADMAP, 'map_style']
            }
          });


  // Create a map object, and include the MapTypeId to add
  // to the map type control.
  //Associate the styled map with the MapTypeId and set it to display.
    // WENN KARTE BEWEGT WIRD search() AUFRUFEN UND ERGEBNISSE AKTUALISIEREN

        map.addStyle({
            styledMapName:"Styled Map",
            styles: styles,
            mapTypeId: "map_style"
        });

        map.setStyle("map_style");
    // map.addMarkers(markers);
    var markers = addMarkerToMap();
    map.addMarkers(markers);

        if(markers.length == 1) {
            // console.log('setZomm'),
            map.setZoom(16);
        }

    if(markers.length >= 1) {
        if($(this).hasClass('map-half')) {
            var latlng = new google.maps.LatLng(parseFloat(markers[0].lat), parseFloat(markers[0].lng));
            // console.log(parseFloat(markers[0].lat));
            map.setCenter(parseFloat(markers[0].lat),parseFloat(markers[0].lng));
        }
    }
        // var latlng = new google.maps.LatLng(markers[0].lat, markers[0].lng);
        // map.setCenter(latlng);
        maps[$id] = map;
    });

    // INIT GROESSE UND KOSTEN SLIDER
    }
}
// addMarkerToMap();
function addMarkerToMap(remove) {
    if(_.exists('.map')) {
    markers = [];
        // if(typeof remove !== 'undefined') {
        // map.removeMarkers();
        // }
        $.each(maps, function(index, val) {
            val.removeMarkers();
             /* iterate through array or object */
        });
        var $image = {
            url: $urlPrefix + '/Assets/Svg/marker_neu.png'
        };

        if($('html').hasClass('ie')) {
            $image = {
                url: $urlPrefix + '/Assets/Svg/marker_neu.png'
                // scaledSize: new google.maps.Size(30, 30)
            }
        }
        $('.filiale').each(function(){
            if(!$(this).hasClass('no-results')) {
                var lat = $(this).attr('data-lat');
                var lng = $(this).attr('data-lng');
                var title = '';
                if(typeof lat != 'undefined') {
                    // console.log('what');
                    markers.push({
                        lat: lat,
                        lng: lng,
                        title: title,
                        icon: $image,

                        infoWindow: {
                            content: '<div class="filiale object-map">' + $(this).html() + '</div>'
                        },
                        click: function(e) {
                            setTimeout(function(){
                                console.log( $('.gm-style-iw').parent().parent());
                                $('.gm-style-iw').parent().parent().addClass('info-gmaps');

                                mbiImageSize.init();
                            },1);
                        }
                    });
                }
            }
        });

        return markers;
    } else {
        return
    }

}
    $(document).on('click', '.js_focus-map', function(){
        $('.js_focus-map').removeClass('is_open');
        $(this).addClass('is_open');
        var tlat = $(this).attr('data-lat');
        var tlng = $(this).attr('data-lng');
        var latlng = new google.maps.LatLng(parseFloat(tlat), parseFloat(tlng));
        // console.log(parseFloat(markers[0].lat));
        var idmap = $(this).parents('.section-filialen').find('.map').attr('id');
        maps[idmap].panTo(latlng);
        // console.log(latlng);
             // map.setCenter(latlng);
        // map.setCenter(new google.maps.LatLng(tlat, tlng));
    });

    $(document).on('click', '.js_filter', function(){
        var filter = $(this).attr('data-filter');
        $(document).find('.filialen-ort-wrapper').addClass('is_hidden');
        var active = $(document).find('[data-for-filter="'+filter+'"]');
        $(active).removeClass('is_hidden');
        $(active).find('.filiale').first().trigger('click');
        if('lap-' in mbiMq.mqArea) {
            $('html, body').animate({
                scrollTop: $('.filialen-wrapper').offset().top - 80
            }, 300);
        }
        $('.filialen-wrapper').animate({
            scrollTop: 0
        },300);

    });
    $(document).on('click', '.js_filter-all', function(){
        $(document).find('.filialen-ort-wrapper').removeClass('is_hidden');
        $(document).find('.filiale').first().trigger('click');
        if('lap-' in mbiMq.mqArea) {
            $('html, body').animate({
                scrollTop: $('.filialen-wrapper').offset().top - 80
            }, 300);
        }
        $('.filialen-wrapper').animate({
            scrollTop: 0
        },300);
    });

    $(document).on('click', '.js_open-accordion', function(){
        // $('.accordion-body').removeClass('is_open');
        $(this).toggleClass('is_open');
        $(this).siblings('.accordion-body').toggleClass('is_open');
    });

    $(document).on('click', '.js_show-map', function(){
        $(this).toggleClass('is_open');
        var $this = $(this);
        if($(this).hasClass('is_open')) {
            setTimeout(function(){
                $this.html($this.attr('data-close'));
            },300)
        } else {
            setTimeout(function(){
                $this.html($this.attr('data-open'));
            }, 300)
        }
        $('.map-half').toggleClass('is_open');
    });

    $(document).on('click', '.js_send-gewinnspiel', function(){
        var form = $('#gewinnspiel');

        // console.log(form);
        // form.validate();
        form.find('input, textarea').removeClass('error');
        if(form.valid()) {
            $.ajax({
                type: 'POST',
                data: {
                    form: form.serializeArray(),
                    mode: 'sendgewinnspiel',
                    frage: $(document).find('.inner .text').html()
                },
                success: function(data) {
                    if(data != "error") {

                        $('.msg-gewinnspiel').addClass('is_active');
                        $('#gewinnspiel').addClass('is_hidden');
                        form.find('input').removeClass('error');
                        // form.find('.input-email').val(form.find('.input-email').attr('data-thx')).prop('disabled', true);
                        $('.js_send-gewinnspiel').addClass('is_disabled').remove();
                    } else {
                        form.find('input').addClass('error');
                    }
            }
            });
        } else {
            // form.find('input').addClass('error');
            // form.find('input, textarea').addClass('error');
        }
    });

    $(document).on('click', '.js_menuToggle', function(){
        if($('body').hasClass('menu_open')) {
            $('body').removeClass('menu_open');
        } else {
            var speed = $(document).scrollTop();
            // console.log(speed);
            $('html, body').animate({
                scrollTop: 0
            }, speed / 8);

            setTimeout(function(){
                $('body').toggleClass('menu_open');
            },(speed / 8) + 50);
        }
    });


    // setTimeout(function() {
    //     if ($.cookie('cookiemsg') != 'confirmed') {
    //         $('.cookiemsg').addClass('is_active');
    //     } else {
    //         $('.cookiemsg').remove();
    //     }
    // }, 2000);

    // $(document).on('click', '.js_savecookie',function(){
    //     $.cookie('cookiemsg', 'confirmed', { expires: 7, path: '/' });
    //     $('.cookiemsg').removeClass('is_active');
    // });

$(document).on('submit', '#mc-embedded-subscribe-form', function(e){
    e.preventDefault();
    var form = $('#mc-embedded-subscribe-form');
    if(isValidEmailAddress(form.find('.input-email').val())) {
        $('input').removeClass('error');
        $.ajax({
            type: 'POST',
            data: {
                form: form.serializeArray(),
                mode: 'newsletter'
            },
            success: function(data) {
                // console.log(data['status']);
                data = $.parseJSON(data);
                console.log(data);
                if (data['status'] == 201) { // 201 = New resource has been created
                    form.find('.input-email').removeClass('error');
                    form.find('input').val('');
                    form.find('#mc-embedded-subscribe').val(form.find('.input-email').attr('data-thx'));
                    form.find('input').prop('disabled', true);
                    form.find('.msg').addClass('is_active');
                    $('.js_send-nl').addClass('is_disabled');
                } else if (data['status'] == 200) { // Successful request (but nothing created)
                    form.find('.input-email').addClass('error');
                    form.find('.error-msg').addClass('is_active');
                } else {
                    form.find('.input-email').addClass('error');
                    form.find('.msg').removeClass('is_active');
                }
        },
        error: function() {
            console.log('error!');
        }
    });
    } else {
        $('.input-email').addClass('error');
        if(!$('#zustimmen').prop('checked')) {
        // console.log('zustimmen is checked');
            $('#zustimmen').addClass('error');
        } else {
            $('#zustimmen').removeClass('error');
        }
        if(!$('#datenschutz').prop('checked')) {
            $('#datenschutz').addClass('error');
            // console.log('zustimmen is checked');
        } else {
            $('#datenschutz').removeClass('error');
        }
        if($('#mce-FNAME').val() != '') {
            $('#mce-FNAME').removeClass('error');
        } else {
            $('#mce-FNAME').addClass('error');
        }
        if($('#mce-LNAME').val() != '') {
            $('#mce-LNAME').removeClass('error');
        } else {
            $('#mce-LNAME').addClass('error');
        }
    }
});


function isValidEmailAddress(emailAddress) {
    if($('#zustimmen').prop('checked')) {
        // console.log('zustimmen is checked');
        $('#zustimmen').removeClass('error');
    } else {
        return false;
    }
    if($('#datenschutz').prop('checked')) {
        // console.log('zustimmen is checked');
        $('#datenschutz').removeClass('error');
    } else {
        return false;
    }
    if($('#mce-FNAME').val() != '') {
        $('#mce-FNAME').removeClass('error');
    } else {
        return false;
    }
    if($('#mce-LNAME').val() != '') {
        $('#mce-LNAME').removeClass('error');
    } else {
        return false;
    }

    // if($('#mce-FNAME').val() != '') {
    //     $('#mce-FNAME').removeClass('error');
    // }
    var pattern = /^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;
    return pattern.test(emailAddress);
};

V.validateForm('gewinnspiel');
initMap();
initSwiper();
});
define("Assets/Js/Footer.js", function(){});

